import { z } from 'zod';
/**
 * Toplu gönderi sorgulama.
 *
 * Kullanıcı bilgisayarda elindeki gönderi listesini alt alta yapıştırır ve
 * tek seferde "bunlardan hangileri sisteme girilmiş" sorusunu sorar. Cevap
 * iki listedir: eşleşenler ve kaydı bulunamayanlar.
 *
 * Tek tek sorgulamak (resimden sorgulama ekranındaki gibi) burada işe
 * yaramaz: orada bir fotoğrafta birkaç kod olur, burada yüzlerce satır
 * yapıştırılıyor. Her kod için ayrı istek, ağ gidiş-dönüşü yüzünden
 * dakikalar sürerdi.
 */
/** Tek istekte sorgulanabilecek en fazla kod. */
export const BULK_LOOKUP_MAX_CODES = 5000;
export const bulkLookupRequestSchema = z.object({
    /** Yapıştırılan ham metin; ayrıştırma sunucuda yapılır. */
    text: z.string().min(1).max(500_000),
});
export function parseKodCiftleri(metin) {
    const ciftler = [];
    const atlananlar = [];
    const gorulen = new Map();
    const satirlar = metin.split(/\r?\n/);
    for (let i = 0; i < satirlar.length; i++) {
        const ham = satirlar[i] ?? '';
        const satirNo = i + 1;
        if (!ham.trim())
            continue;
        /**
         * Sütun sırası korunuyor: boşlar ayıklanmıyor.
         *
         * Ayıklansaydı ikinci sütunu boş olan bir satır "sütun yok" gibi
         * görünürdü; kullanıcı da kopyalama biçiminin bozuk olduğunu sanıp
         * gerçekte kaynak veride eksik olan alanı arardı.
         */
        const parcalar = ham.split(/[\t;,]/).map((p) => p.trim());
        if (parcalar.length < 2) {
            atlananlar.push({ satir: satirNo, sebep: 'ikinci sütun yok' });
            continue;
        }
        const barkod = parcalar[0] ?? '';
        const siparis = parcalar[1] ?? '';
        if (!barkod) {
            atlananlar.push({ satir: satirNo, sebep: 'barkod boş' });
            continue;
        }
        if (!siparis) {
            atlananlar.push({ satir: satirNo, sebep: 'ikinci sütun boş' });
            continue;
        }
        // Başlık satırı sessizce atlanır; "barkod / sipariş" yazan satır veri değil.
        if (i === 0 && /barkod|barcode/i.test(barkod) && /sipari|order/i.test(siparis)) {
            continue;
        }
        const anahtar = barkod.toUpperCase();
        const once = gorulen.get(anahtar);
        if (once !== undefined) {
            atlananlar.push({ satir: satirNo, sebep: `barkod tekrarı (satır ${once})` });
            continue;
        }
        gorulen.set(anahtar, satirNo);
        ciftler.push({ barkod, siparis, satir: satirNo });
    }
    return { ciftler, atlananlar };
}
//# sourceMappingURL=bulkLookup.js.map